import { useEmailNurturing } from "@/hooks/useEmailNurturing";

export function EmailNurturingManager() {
  // This hook handles the email nurturing logic
  useEmailNurturing();
  
  // This component doesn't render anything
  return null;
}
